var exports = {
  "kL": "ChannelPermissionsTab.module__container___RVFXcU",
  "Ut": "ChannelPermissionsTab.module__syncBanner___RVFXcU",
  "iH": "ChannelPermissionsTab.module__syncBannerSynced___RVFXcU",
  "bT": "ChannelPermissionsTab.module__syncBannerUnsynced___RVFXcU",
  "Vg": "ChannelPermissionsTab.module__grid___RVFXcU",
  "s4": "ChannelPermissionsTab.module__leftTitle___RVFXcU",
  "pG": "ChannelPermissionsTab.module__right___RVFXcU",
  "ze": "ChannelPermissionsTab.module__rightScroller___RVFXcU",
  "CI": "ChannelPermissionsTab.module__sectionRow___RVFXcU",
  "bV": "ChannelPermissionsTab.module__sectionHeader___RVFXcU",
  "Gf": "ChannelPermissionsTab.module__sectionTitle___RVFXcU",
  "bQ": "ChannelPermissionsTab.module__subtleText___RVFXcU",
  "cy": "ChannelPermissionsTab.module__permHeaderRow___RVFXcU",
  "mA": "ChannelPermissionsTab.module__permHelp___RVFXcU",
  "p$": "ChannelPermissionsTab.module__emptyState___RVFXcU",
  "rV": "ChannelPermissionsTab.module__overwriteItem___RVFXcU",
  "w7": "ChannelPermissionsTab.module__overwriteItemSelected___RVFXcU",
  "Vd": "ChannelPermissionsTab.module__overwriteItemContextMenuOpen___RVFXcU",
  "FD": "ChannelPermissionsTab.module__overwriteIcon___RVFXcU",
  "m4": "ChannelPermissionsTab.module__roleDot___RVFXcU",
  "l": "ChannelPermissionsTab.module__overwriteName___RVFXcU",
  "Fs": "ChannelPermissionsTab.module__permSearchRow___RVFXcU",
  "XZ": "ChannelPermissionsTab.module__permSearchInput___RVFXcU",
  "sN": "ChannelPermissionsTab.module__layoutButtons___RVFXcU",
  "Zh": "ChannelPermissionsTab.module__layoutButton___RVFXcU",
  "HU": "ChannelPermissionsTab.module__permCategories___RVFXcU",
  "Fv": "ChannelPermissionsTab.module__mobileOverrideList___RVFXcU",
  "E_": "ChannelPermissionsTab.module__mobileListHeader___RVFXcU",
  "JJ": "ChannelPermissionsTab.module__mobileListTitle___RVFXcU",
  "_4": "ChannelPermissionsTab.module__mobileOverrides___RVFXcU",
  "Ud": "ChannelPermissionsTab.module__mobileOverrideItem___RVFXcU",
  "wP": "ChannelPermissionsTab.module__mobileOverrideName___RVFXcU",
  "wu": "ChannelPermissionsTab.module__mobileOverrideChevron___RVFXcU",
  "yg": "ChannelPermissionsTab.module__mobileBackRow___RVFXcU",
};

module.exports = exports;
